import React, { Component } from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import LoadField from '../components/LoadField';
import MoneyField from '../components/MoneyField';
import { WAButton } from '../components/Button.js';

require(`../assets/${process.env.PAGE}/css/components/Summary.css`);

import { getComissionFromCashAdvance } from '../utils/montemar';

import axios from 'axios';

class Summary extends Component {

    constructor(props) {
        super(props);
        this.state = {

            requested_amount: 5999,
            requested_quotas: 18,
            total_amount: null,
            quota_amount: 4000,
            product_commission: null,
            interest: null,
            interest_tax: null,
            first_payment_date: null,
        };
    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/details`, config)
            .then(res => {
                const data = res.data;
                let total_amount = data.requested_quotas * data.quota_amount;
                let interest_tax = ((total_amount - data.requested_amount) * 0.21) / 1.21
                let interest = (total_amount - data.requested_amount) - interest_tax;
                this.setState({ 'requested_amount': data.requested_amount });
                this.setState({ 'requested_quotas': data.requested_quotas });
                this.setState({ 'quota_amount': data.quota_amount });
                this.setState({ 'total_amount': total_amount });
                this.setState({ 'product_commission': data.product_commission });
                this.setState({ 'interest': interest });
                this.setState({ 'interest_tax': interest_tax });
                this.setState({ 'first_payment_date': data.first_payment_date });
            }
        );
    }

    render() {
        return (
            <div className="summary text-center">
                <div className="summary_details">
                    <h4> Resumen de tu solicitud </h4>
                    <h4> Adelanto </h4>
                    <Row className="summary_row summary_row_vertical_align requested_amount">
                    <moneyField/>
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_requested_amount"
                                                  description="Checkout requested amount"/>
                        </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                { this.state.requested_amount && (<MoneyField decimals={2} >{ this.state.requested_amount }</MoneyField>) }
                            </LoadField>
                        </Col>
                    </Row>
                    <div className="summary_line requested_amount"></div>
                    <Row className="summary_row quota_amount">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_quota_amount"
                                                  description="Checkout quota amount"/>
                        </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                { this.state.quota_amount && (<MoneyField>{ this.state.quota_amount }</MoneyField>) }
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row requested_quotas">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_requested_quotas"
                                                  description="Checkout requested quotas"/>
                        </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                {this.state.requested_quotas}
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row requested_quotas">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_comission"
                                                  description="Checkout comission"/>
                        </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                { (this.state.requested_amount && this.state.product_commission) && (<MoneyField decimals={2} >{ getComissionFromCashAdvance(this.state.requested_amount, this.state.product_commission) }</MoneyField>) }
                            </LoadField>
                        </Col>
                    </Row>
                    <div className="summary_line other_costs"></div>
                    <Row className="summary_row summary_row_vertical_align other_costs">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_other_costs"
                                                  description="Checkout other costs"/>
                        </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>$ 0</Col>
                    </Row>
                    <div className="summary_line payment_date"></div>
                    <Row className="summary_row summary_row_vertical_align payment_date">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_first_payment_date"
                                                  description="Checkout payment date"/>
                        </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_first_payment_date_info"
                                                  description="Checkout payment date info"/>
                        </Col>
                    </Row>
                    <div className="summary_line"></div>
                    <Row className="summary_row">
                        <Col className="summary_col text-left" xs={12} md={12} lg={12}>
                            <FormattedHTMLMessage id="app.step_checkout_info" description="Checkout advice"/>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

Summary.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

export default Summary;



/** WEBPACK FOOTER **
 ** ./src/components/MontemarAdelantosSummary.js
 **/